import React, { ReactNode, useCallback } from 'react';
import { Button, Modal } from 'antd';
import { useDispatch } from 'react-redux';
import { toggleBillingModal } from '@redux/actions/modalAction';
import { ReactComponent as ContributorsLimitErrorSvg } from '@assets/icons/contributors_limit_error_notification.svg';
import { ReactComponent as CrossSvg } from '@assets/icons/cross.svg';

import './LimitReachedModal.less';

type LimitReachedModalProps = {
  isOpen: boolean;
  title: string;
  text?: string | ReactNode;
  onCancel: () => void;
};

export default function LimitReachedModal({
  isOpen,
  title,
  text,
  onCancel
}: LimitReachedModalProps) {
  const dispatch = useDispatch();

  const onUpgrade = useCallback(() => {
    onCancel();
    dispatch(toggleBillingModal({ visible: true }));
  }, [onCancel, dispatch]);

  return (
    <Modal
      open={isOpen}
      destroyOnClose
      onCancel={onCancel}
      footer={null}
      centered={true}
      width={512}
      zIndex={1010}
      className="limit-reached-modal"
    >
      <CrossSvg className="limit-reached-modal_btn-close" onClick={onCancel} />
      <div className="limit-reached-modal_head">
        <ContributorsLimitErrorSvg />
        {title}
      </div>
      {text && <div className="limit-reached-modal_text">{text}</div>}
      <div className="limit-reached-modal_buttons">
        <Button type="text" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          type="primary"
          onClick={onUpgrade}
          style={{
            minWidth: 152
          }}
        >
          Upgrade
        </Button>
      </div>
    </Modal>
  );
}
